import { AlertTriangle, Bell, Clock3, Inbox } from "lucide-react";
import { NotificationKpiCard } from "./NotificationKpiCard";

interface NotificationStats {
  unread: number;
  critical: number;
  warnings: number;
  currentPage: number;
}

export function NotificationKpiGrid({ stats, total }: { stats: NotificationStats; total: number }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <NotificationKpiCard
        label="Non lues"
        value={stats.unread}
        detail="Messages à traiter"
        icon={Bell}
        tone={stats.unread > 0 ? "gold" : "neutral"}
      />
      <NotificationKpiCard
        label="Critiques"
        value={stats.critical}
        detail="Sur la page courante"
        icon={AlertTriangle}
        tone={stats.critical > 0 ? "danger" : "neutral"}
      />
      <NotificationKpiCard
        label="Alertes"
        value={stats.warnings}
        detail="Sur la page courante"
        icon={Clock3}
        tone={stats.warnings > 0 ? "warning" : "neutral"}
      />
      <NotificationKpiCard
        label="Affichées"
        value={stats.currentPage}
        detail={`${total} notification${total !== 1 ? "s" : ""} trouvée${total !== 1 ? "s" : ""}`}
        icon={Inbox}
        tone="neutral"
      />
    </div>
  );
}
